<template>
  <v-card class="sql-formatter tools-view-card">
    <ToolbarHeader :name="'SQL Formatter'"/>
    <v-container>
      <section class="ma-5">
        <v-form>
          <label>
            SQL
          </label>
          <editor
              v-model="form.sql"
              @init="initTextEditor"
              width="100%"
              height="60vh">
          </editor>
          <v-btn
              class="mt-3"
              color="primary"
              @click="formatSQL"
          >
            Format
          </v-btn>
          <v-row v-if="sql.error"
                 class="justify-center">
            <v-col cols="12"
                   sm="12"
                   md="12">
              <v-alert
                  type="error">
                {{ sql.error }}
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import sqlFormatter from "sql-formatter";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const form = {
  sql: 'Select distinct Salary from Employee e1 where 2=Select count(distinct Salary) from Employee e2 where e1.salary<=e2.salary',
};


export default {
  name: "SQL-Formatter",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader
  },
  data: () => ({
    form: Object.assign({}, form),
    sql: {
      error: ''
    }
  }),
  methods: {
    formatSQL() {
      if (!this.form.sql) {
        return;
      }

      try {
        this.form.sql = sqlFormatter.format(this.form.sql)
      } catch (error) {
        this.sql.error = error;
      }

    }
  }
}
</script>

<style scoped>

</style>
